export enum EventType {
  AlertNew = 'alert-new',
  AlertRead = 'alert-read',
  ConnectedUser = 'connected-user',
  ImportProgress = 'import-progress',
  NewSession = 'new-session',
  Notification = 'notification',
  UserInStore = 'user-in-store',
}
